import { Injectable } from '@angular/core';
import {SclMapConstantService} from './scl-map-constant.service';
import { AddressDetails } from './AddressDetails';
const sclMapConstant = SclMapConstantService;

// Reverse example:
// https://revgeocode.search.hereapi.com/v1/
//     revgeocode
//     ?at=48.2181679%2C16.3899064
//     &lang=en-US
//     &apiKey={YOUR_API_KEY}

// Look up example: 
// https://geocode.search.hereapi.com/v1/
//     geocode
//     ?q=240+Washington+St.%2C+Boston
//     &apiKey={YOUR_API_KEY}

@Injectable({
  providedIn: 'root'
})
export class SclMapGeoHereService {

  constructor() { }

  autocompleteUrl = 'https://geocode.search.hereapi.com/v1/geocode';
  geocodeUrl = 'https://revgeocode.search.hereapi.com/v1/revgeocode';
  
  autocompleteBox;
  apiKey;
  waitTime = 5000; // miliseconds
  radius = 50;
  initObj;
  preText = '';
  autocompleteStreet;
  state; country;
  hasPrimaryAssetAddressLookup = false; primaryAssetAddressLookupRadius; // 15393

  setSuburb(address) {
    const gotDistrict = address.label.indexOf(address.district);
    const gotCity = address.label.indexOf(address.city);

    if (gotDistrict >= 0 && gotCity >= 0) {
      if (gotDistrict < gotCity) {
        return address.city;
      } else {
        return address.district;
      }
    } else if (gotDistrict < 0) {
      return address.city;
    } else {
      return address.district;
    }
  }

  setupReverse(geo){
    if (geo.radius) {
      this.radius = geo.radius;
    }
    if (geo.primaryAssetAddressLookupRadius) { this.primaryAssetAddressLookupRadius = geo.primaryAssetAddressLookupRadius; }
  }

  reverse( coor, cb, cbErr, cbTimeout) {
    if ( this.apiKey == null) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('here.com address reverse: apiKey is null');
      }
      return;
    }

    const lat = coor[1]; const lon = coor[0]; let radius = coor[2];
    if (this.hasPrimaryAssetAddressLookup === true) { radius = this.primaryAssetAddressLookupRadius; }
    else { radius = this.radius; }
    let link = `${this.geocodeUrl}?apiKey=${this.apiKey}&at=${lat},${lon}`;
    // link = this.getLinkOptions( link);
    console.log(`**** HERE, reverse link = `, link);
    this.initObj.httpService.getAPI(link, {timeout: this.waitTime})
      .subscribe(data => {
          if (data && data.items && data.items.length > 0) {
            const suggestions = data.items[0];

            const address = suggestions.address;
            const streetData: any = new AddressDetails();

            if (address) {
              streetData.properties.streetNo = address.houseNumber;
              streetData.properties.street = address.street;
              streetData.properties.suburb = this.setSuburb(address);
              streetData.properties.postcode = address.postalCode;
              streetData.properties.country = address.countryName;
              streetData.properties.state = address.state;
              streetData.geometry.coordinates = [lon, lat];
            }
            const position = suggestions.position;
            const cbLat = position?.lat ?? lat;
            const cbLon = position?.lng ?? lon;
            
            if (cb && typeof cb === 'function') {
              cb(streetData, { lat: cbLat, lng: cbLon });
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('here.com reverse address lookup Error');
            }
          }
        },
        err => {
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            // logger.info(err);
            if (cbErr && typeof cbErr === 'function') {
              cbErr('here.com reverse address lookup Error');
            }
          }
        });
    }

  lookUp(params, cb, cbErr, cbSelectOption, cbRemoveStreet, cbTimeout ) {

      if (params == null || params.length < 1) {
        if (cbErr && typeof cbErr === 'function') {
          cbErr('params is invalid, [0] : autocompleteBox');
        }
        return;
      }
      if (this.autocompleteBox == null) {
        this.autocompleteBox = params[0];
      }


      if (params.length > 1) {
        this.search(params[1], cb, cbErr, cbTimeout);
      }

    }

  removeLookUp() {
      const id = this.initObj.keyName + 'MapGeoHere';
      const elem = document.getElementById(id);
      if (elem) {
        elem.remove();
      }

      this.autocompleteBox = null;
    }

  removeStreet(cb) {
      if (this.autocompleteStreet == null) {
        this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
      }
      if (this.autocompleteStreet == null) {
        if (cb && typeof cb === 'function') {
          cb();
        }
        return;
      }
      this.autocompleteStreet.value = '';

      if (cb && typeof cb === 'function') {
        cb();
      }
    }

  search(sPartialAddress, cb, cbErr, cbTimeout) {
    if ( !this.apiKey) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('here.com address lookup: apiKey is null');
      }
      return;
    }
    if ( sPartialAddress == null ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('here.com address lookup: text is null');
      }
      return;
    }

    const results = [];

    const newText = sPartialAddress.trim();
    if (newText === this.preText) {
      if (cb && typeof cb === 'function') {
        cb([]);
      }
      return;
    }

    this.preText = newText;

    if ( newText.length < 3 ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('here.com address lookup: text is less than 3 characters');
      }
      return;
    }

    sPartialAddress = this.getAddressOptions(sPartialAddress);

    let link = `${this.autocompleteUrl}?q=${sPartialAddress}&apiKey=${this.apiKey}`
    
    this.initObj.httpService.getAPI(link, {timeout: this.waitTime})
      .subscribe(data => {
          if (data && data.items && data.items.length > 0) {
            const suggestions = data.items;

            for (let i = 0; i < suggestions.length; i++) {
              const predict = suggestions[i];
              const sugg: any = {};
              sugg.street = predict.title;
              sugg.address = predict.address;
              sugg.coordinates = predict.position;
              results.push(sugg);
            }
            //// logger.info('result = ' + JSON.stringify(results));

            if (cb && typeof cb === 'function') {
              cb(results);
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('here.com address lookup Error ');
            }
          }
        },
        err => {
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            // logger.info(err);
            if (cbErr && typeof cbErr === 'function') {
              cbErr('here.com address lookup Error ');
            }
          }

        });
  }

  selectionOption(tpl, model, cb) {
    const address = tpl.address; const coordinates = tpl.coordinates;
    const obj: any = new AddressDetails();

    obj.properties.streetNo = address.houseNumber;
    obj.properties.street = address.street;
    obj.properties.suburb = this.setSuburb(address);
    obj.properties.postcode = address.postalCode;
    obj.properties.country = address.countryName;
    obj.properties.state = address.state;

    obj.geometry.coordinates = [ coordinates.lng, coordinates.lat ];


    if (cb && typeof cb === 'function') {
      cb(obj);
    }
  }

  getAddressOptions( address) {
      if (this.state) { address += '+' + this.state; }
      if (this.country) { address += '+' + this.country; }

      return address;
    }

}
